import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Snackbar } from '@bcmi-labs/react-components';
import { Banners, OldUserLoginSbackbarMessageApps } from '../LoginBanners';

import './LoginSelector.scss';

const LoginSelector = (props) => {
  const { t } = useTranslation('login');

  const [showOldStudentMessage, setShowOldStudentMessage] = useState(
    window.auth0Config && OldUserLoginSbackbarMessageApps.includes(window.auth0Config.clientID)
  );

  return (
    <section className="login-selector">
      <h1 className="arduino-typography-large">{t('login:signInTitle')}</h1>
      {/* Show a custom banner for each client ID in the banners object */}
      {window.auth0Config && Banners[window.auth0Config.clientID] && (
        <p className="description">{t(`login:banners:${Banners[window.auth0Config.clientID].message}`)}</p>
      )}

      <div className="selection-wrapper">
        <button className="selection-card" onClick={() => props.onViewSelection('kid-login')}>
          <h3 className="selection-card-title">{t('login:asJunior')}</h3>
          <div className="selection-image-wrapper kid"></div>
        </button>
        <button className="selection-card" onClick={() => props.onViewSelection('adult-login')}>
          <h3 className="selection-card-title">{t('login:asAdult')}</h3>
          <div className="selection-image-wrapper adult"></div>
        </button>
      </div>

      <div className="create-divider">
        <span>
          {t('login:noAccount')}{' '}
          <Link className="register-link" to="/register">
            {t('login:createAccount')}
          </Link>
        </span>
      </div>

      <div className="spacer"></div>
      {/* TODO: delete after few months */}
      <Snackbar
        message={t('login:registeredAsStudent')}
        isOpen={showOldStudentMessage}
        onClose={() => setShowOldStudentMessage(false)}
        ActionElement={<span onClick={() => props.onViewSelection('kid-login')}>{t('login:loginHere')}</span>}
        turnOffAutoHide
        closeable
      ></Snackbar>
    </section>
  );
};

LoginSelector.propTypes = {
  onViewSelection: PropTypes.func.isRequired,
};

export default LoginSelector;
